export function symcodsoumission(){
	
	let _next_select;

	function get_produits_select_content( a,b ){
		
		jQuery.ajax({
			type : "post",
			dataType : "json",
			url : Documentation.ajaxurl,
			data : {
				action: "form_produits_select_content",
				term_a : a,
				term_b : b,
				mynonce : Documentation.docuNonce
			},
			beforeSend: function(){
			
			}
			}).done( function(response) {
				console.log(response);
				_next_select = jQuery("#" + response.term_b );
				_next_select.html(response.options);
				
			}).fail(function(jqXHR, textStatus, errorThrown){
			 
			}).always(function(response) {
			});		
	}
		
	jQuery(".famille-produit").on("change","select", function(e){
		e.preventDefault();
		var _ = jQuery(this);
		var _att = _.val();
		var _li_parent = _.parent().parent().next().find(".gfield_select").attr("id");
		get_produits_select_content( _att , _li_parent );
	
	});
	
	
	jQuery(".add-product-retour").on("change",'input[type="checkbox"]',function(){
		if(jQuery(this).is(":checked")) {
			jQuery(this).next('label').html('enlever le produit');
    	} else{
	    	jQuery(this).next('label').html('ajouter un produit');
    	}
	});

	
/*
	jQuery(window).load(function(){
		var _ = jQuery("#input_4_23");
		var _att = _.val();
		var _li_parent = _.parent().parent().next().find(".gfield_select").attr("id");
		get_produits_select_content( _att , _li_parent );
	});
*/
	
}